import ReactRRuleGenerator from './lib/components/ReactRRuleGenerator';
import translations from './lib/translations';

export default ReactRRuleGenerator;
export { translations };
